// import React, { useState, useEffect } from 'react';
// import { useNavigate } from 'react-router-dom';
// import axios from 'axios';
// import Cookies from 'js-cookie';
// import DpinModal from './DpinModal';
// import SearchableSelect from './SearchableSelect';


// const Invoices = () => {
//   const navigate = useNavigate();
//   const [invoices, setInvoices] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState('');
//   const [success, setSuccess] = useState('');

//   // Pagination
//   const [currentPage, setCurrentPage] = useState(1);
//   const [totalPages, setTotalPages] = useState(1);
//   const [totalInvoices, setTotalInvoices] = useState(0);
//   const [limit, setLimit] = useState(10);

//   // Checkbox selection
//   const [selectedInvoices, setSelectedInvoices] = useState([]);
//   const [selectAll, setSelectAll] = useState(false);

//   // DPIN Modal states
//   const [showDpinModal, setShowDpinModal] = useState(false);
//   const [invoiceToDelete, setInvoiceToDelete] = useState(null);
//   const [bulkDeleteMode, setBulkDeleteMode] = useState(false);

//   // Download Modal states
//   const [showDownloadModal, setShowDownloadModal] = useState(false);
//   const [downloadInvoiceId, setDownloadInvoiceId] = useState(null);
//   const [downloadOptions, setDownloadOptions] = useState({
//     withLetterhead: false,
//     withIGST: false,
//     rememberChoice: false
//   });

//   // Filter states
//   const [customers, setCustomers] = useState([]);
//   const [financialYears, setFinancialYears] = useState([]);
//   const [filters, setFilters] = useState({
//     customer: '',
//     invoiceDate: '',
//     createdDate: '',
//     financialYear: getCurrentFinancialYear(),
//     invoiceNumber: '',
//     status: '',
//     invoiceType: ''
//   });

//   // Helper function to get current financial year
//   function getCurrentFinancialYear() {
//     const today = new Date();
//     const currentMonth = today.getMonth() + 1;
//     const currentYear = today.getFullYear();

//     if (currentMonth >= 4) {
//       return `${currentYear}-${currentYear + 1}`;
//     } else {
//       return `${currentYear - 1}-${currentYear}`;
//     }
//   }

//   // Generate financial years list
//   function generateFinancialYears() {
//     const years = [];
//     const currentDate = new Date();
//     const currentYear = currentDate.getFullYear();

//     for (let year = 2020; year <= currentYear + 1; year++) {
//       years.push(`${year}-${year + 1}`);
//     }

//     return years;
//   }

//   // Load saved download preferences
//   useEffect(() => {
//     const savedOptions = localStorage.getItem('invoiceDownloadPreferences');
//     if (savedOptions) {
//       setDownloadOptions(JSON.parse(savedOptions));
//     }
//   }, []);

//   useEffect(() => {
//     fetchCustomers();
//     setFinancialYears(generateFinancialYears());
//     fetchInvoices();
//   }, []);

//   useEffect(() => {
//     fetchInvoices();
//   }, [currentPage, limit]);

//   const fetchCustomers = async () => {
//     try {
//       const token = Cookies.get('token');
//       const response = await axios.get('https://app-pune-ndt.cloud/api/customers', {
//         headers: { Authorization: `Bearer ${token}` }
//       });
//       if (response.data.success) {
//         setCustomers(response.data.data);
//       }
//     } catch (err) {
//       console.error('Error fetching customers:', err);
//     }
//   };

//   const fetchInvoices = async () => {
//     setLoading(true);
//     setError('');

//     try {
//       const token = Cookies.get('token');
//       const response = await axios.get('https://app-pune-ndt.cloud/api/invoices/filter', {
//         headers: { Authorization: `Bearer ${token}` },
//         params: {
//           page: currentPage,
//           limit: limit,
//           customer: filters.customer,
//           invoiceDate: filters.invoiceDate,
//           createdDate: filters.createdDate,
//           financialYear: filters.financialYear,
//           invoiceNumber: filters.invoiceNumber,
//           status: filters.status,
//           invoiceType: filters.invoiceType
//         }
//       });

//       if (response.data.success) {
//         setInvoices(response.data.data);
//         setTotalPages(response.data.pagination.totalPages);
//         setTotalInvoices(response.data.pagination.total);
//       }
//     } catch (err) {
//       setError('Failed to fetch invoices');
//       console.error('Error fetching invoices:', err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Handle filter change
//   const handleFilterChange = (e) => {
//     const { name, value } = e.target;
//     setFilters(prev => ({
//       ...prev,
//       [name]: value
//     }));
//   };

//   // Handle search
//   const handleSearch = () => {
//     setCurrentPage(1);
//     fetchInvoices();
//   };

//   // Handle clear filters
//   const handleClearFilters = async () => {
//     const clearedFilters = {
//       customer: '',
//       invoiceDate: '',
//       createdDate: '',
//       financialYear: getCurrentFinancialYear(),
//       invoiceNumber: '',
//       status: '',
//       invoiceType: ''
//     };

//     setFilters(clearedFilters);
//     setCurrentPage(1);

//     setLoading(true);
//     setError('');

//     try {
//       const token = Cookies.get('token');
//       const response = await axios.get('https://app-pune-ndt.cloud/api/invoices/filter', {
//         headers: { Authorization: `Bearer ${token}` },
//         params: {
//           page: 1,
//           limit: limit,
//           ...clearedFilters
//         }
//       });

//       if (response.data.success) {
//         setInvoices(response.data.data);
//         setTotalPages(response.data.pagination.totalPages);
//         setTotalInvoices(response.data.pagination.total);
//       }
//     } catch (err) {
//       setError('Failed to fetch invoices');
//       console.error('Error fetching invoices:', err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Handle checkbox selection
//   const handleSelectAll = (e) => {
//     setSelectAll(e.target.checked);
//     if (e.target.checked) {
//       setSelectedInvoices(invoices.map(invoice => invoice.id));
//     } else {
//       setSelectedInvoices([]);
//     }
//   };

//   const handleSelectInvoice = (invoiceId) => {
//     if (selectedInvoices.includes(invoiceId)) {
//       setSelectedInvoices(selectedInvoices.filter(id => id !== invoiceId));
//       setSelectAll(false);
//     } else {
//       const newSelected = [...selectedInvoices, invoiceId];
//       setSelectedInvoices(newSelected);
//       if (newSelected.length === invoices.length) {
//         setSelectAll(true);
//       }
//     }
//   };

//   // Handle Edit
//   const handleEdit = (invoiceId) => {
//     navigate(`/invoices/edit/${invoiceId}`);
//   };

//   // Handle View
//   const handleView = (invoiceId) => {
//     navigate(`/invoices/view/${invoiceId}`);
//   };

//   // Handle Download Invoice - Open Modal
//   const handleDownloadInvoice = (invoiceId, invoiceNumber) => {
//     setDownloadInvoiceId({ id: invoiceId, number: invoiceNumber });
//     setShowDownloadModal(true);
//   };

//   // Handle Download Confirm
//   const handleDownloadConfirm = async () => {
//     try {
//       // Save preferences if remember choice is checked
//       if (downloadOptions.rememberChoice) {
//         localStorage.setItem('invoiceDownloadPreferences', JSON.stringify(downloadOptions));
//       }

//       setSuccess(`Generating invoice PDF for ${downloadInvoiceId.number}...`);

//       const token = Cookies.get('token');
//       const response = await axios.get(
//         `https://app-pune-ndt.cloud/api/invoices/${downloadInvoiceId.id}/download`,
//         {
//           headers: { Authorization: `Bearer ${token}` },
//           params: {
//             withLetterhead: downloadOptions.withLetterhead,
//             withIGST: downloadOptions.withIGST
//           },
//           responseType: 'blob'
//         }
//       );

//       // Create blob and download
//       const url = window.URL.createObjectURL(new Blob([response.data]));
//       const link = document.createElement('a');
//       link.href = url;
//       link.setAttribute('download', `Invoice_${downloadInvoiceId.number.replace(/\//g, '_')}.pdf`);
//       document.body.appendChild(link);
//       link.click();
//       link.remove();
//       window.URL.revokeObjectURL(url);

//       setShowDownloadModal(false);
//       setDownloadInvoiceId(null);
//       setSuccess(`Invoice ${downloadInvoiceId.number} downloaded successfully!`);
//       setTimeout(() => setSuccess(''), 3000);
//     } catch (err) {
//       setError('Failed to download invoice');
//       console.error('Error downloading invoice:', err);
//       setTimeout(() => setError(''), 5000);
//     }
//   };

//   // Handle Download Statement
//   const handleDownloadStatement = async (invoiceId, invoiceNumber) => {
//     try {
//       setSuccess(`Generating statement PDF for ${invoiceNumber}...`);

//       const token = Cookies.get('token');
//       const response = await axios.get(
//         `https://app-pune-ndt.cloud/api/invoices/${invoiceId}/statement`,
//         {
//           headers: { Authorization: `Bearer ${token}` },
//           responseType: 'blob'
//         }
//       );

//       // Create blob and download
//       const url = window.URL.createObjectURL(new Blob([response.data]));
//       const link = document.createElement('a');
//       link.href = url;
//       link.setAttribute('download', `Statement_${invoiceNumber.replace(/\//g, '_')}.pdf`);
//       document.body.appendChild(link);
//       link.click();
//       link.remove();
//       window.URL.revokeObjectURL(url);

//       setSuccess(`Statement ${invoiceNumber} downloaded successfully!`);
//       setTimeout(() => setSuccess(''), 3000);
//     } catch (err) {
//       setError('Failed to download statement');
//       console.error('Error downloading statement:', err);
//       setTimeout(() => setError(''), 5000);
//     }
//   };

//   // Handle Delete - Open DPIN Modal
//   const handleDelete = (invoiceId, invoiceNumber) => {
//     setInvoiceToDelete({ id: invoiceId, number: invoiceNumber });
//     setBulkDeleteMode(false);
//     setShowDpinModal(true);
//   };

//   // Handle Delete Confirmed
//   const handleDeleteConfirmed = async () => {
//     try {
//       const token = Cookies.get('token');
//       const response = await axios.delete(
//         `https://app-pune-ndt.cloud/api/invoices/${invoiceToDelete.id}`,
//         {
//           headers: { Authorization: `Bearer ${token}` }
//         }
//       );

//       if (response.data.success) {
//         setSuccess(`Invoice ${invoiceToDelete.number} deleted successfully! All reports have been set to Unbilled.`);

//         // Remove from selected invoices if it was selected
//         setSelectedInvoices(prev => prev.filter(id => id !== invoiceToDelete.id));

//         // Refresh the invoices list
//         fetchInvoices();

//         setInvoiceToDelete(null);
//         setTimeout(() => setSuccess(''), 5000);
//       }
//     } catch (err) {
//       setError('Failed to delete invoice');
//       console.error('Error deleting invoice:', err);
//       setTimeout(() => setError(''), 5000);
//     }
//   };
//   // Handle Cancel (Delete Invoice Completely)
//   const handleCancel = async (invoiceId, invoiceNumber) => {
//     // Use DPIN modal instead of window.confirm
//     setInvoiceToDelete({ id: invoiceId, number: invoiceNumber, isCancel: true });
//     setBulkDeleteMode(false);
//     setShowDpinModal(true);
//   };

//   // Handle Cancel Confirmed
//   const handleCancelConfirmed = async () => {
//     try {
//       const token = Cookies.get('token');
//       const response = await axios.post(
//         `https://app-pune-ndt.cloud/api/invoices/${invoiceToDelete.id}/cancel`,
//         {},
//         {
//           headers: { Authorization: `Bearer ${token}` }
//         }
//       );

//       if (response.data.success) {
//         setSuccess(`Invoice ${invoiceToDelete.number} cancelled successfully! All reports have been set to Unbilled.`);

//         // Remove from selected invoices if it was selected
//         setSelectedInvoices(prev => prev.filter(id => id !== invoiceToDelete.id));

//         // Refresh the invoices list
//         fetchInvoices();

//         setInvoiceToDelete(null);
//         setTimeout(() => setSuccess(''), 5000);
//       }
//     } catch (err) {
//       setError('Failed to cancel invoice');
//       console.error('Error cancelling invoice:', err);
//       setTimeout(() => setError(''), 5000);
//     }
//   };

//   // Handle Bulk Delete - Open DPIN Modal
//   const handleBulkDelete = () => {
//     if (selectedInvoices.length === 0) {
//       alert('Please select invoices to delete');
//       return;
//     }

//     setBulkDeleteMode(true);
//     setShowDpinModal(true);
//   };

//   // Handle Bulk Delete Confirmed
//   const handleBulkDeleteConfirmed = async () => {
//     try {
//       const token = Cookies.get('token');
//       const response = await axios.post(
//         'https://app-pune-ndt.cloud/api/invoices/bulk-delete',
//         { invoiceIds: selectedInvoices },
//         {
//           headers: { Authorization: `Bearer ${token}` }
//         }
//       );

//       if (response.data.success) {
//         setSuccess(`${selectedInvoices.length} invoice(s) deleted successfully! All associated reports have been set to Unbilled.`);

//         // Clear selected invoices
//         setSelectedInvoices([]);
//         setSelectAll(false);

//         // Refresh the invoices list
//         fetchInvoices();

//         setTimeout(() => setSuccess(''), 5000);
//       }
//     } catch (err) {
//       setError('Failed to delete invoices');
//       console.error('Error deleting invoices:', err);
//       setTimeout(() => setError(''), 5000);
//     }
//   };

//   // Handle DPIN Success
//   const handleDpinSuccess = () => {
//     if (bulkDeleteMode) {
//       handleBulkDeleteConfirmed();
//     } else if (invoiceToDelete?.isCancel) {
//       handleCancelConfirmed();
//     } else {
//       handleDeleteConfirmed();
//     }
//   };

//   // Format date
//   const formatDate = (dateString) => {
//     if (!dateString) return 'N/A';
//     const date = new Date(dateString);
//     const day = String(date.getDate()).padStart(2, '0');
//     const month = String(date.getMonth() + 1).padStart(2, '0');
//     const year = String(date.getFullYear()).slice(-2);
//     return `${day}-${month}-${year}`;
//   };

//   // Format datetime
//   const formatDateTime = (dateString) => {
//     if (!dateString) return 'N/A';
//     const date = new Date(dateString);
//     return date.toLocaleString('en-IN', {
//       year: 'numeric',
//       month: '2-digit',
//       day: '2-digit',
//       hour: '2-digit',
//       minute: '2-digit',
//       second: '2-digit',
//       hour12: false
//     });
//   };

//   // Get status badge color
//   const getStatusBadge = (status) => {
//     const badges = {
//       paid: 'bg-green-100 text-green-800',
//       pending: 'bg-yellow-100 text-yellow-800',
//       overdue: 'bg-red-100 text-red-800',
//       cancelled: 'bg-gray-100 text-gray-800'
//     };
//     return badges[status] || 'bg-gray-100 text-gray-800';
//   };

//   // Get invoice type badge color
//   const getInvoiceTypeBadge = (type) => {
//     return type === 'Film'
//       ? 'bg-blue-100 text-blue-800'
//       : 'bg-purple-100 text-purple-800';
//   };

//   return (
//     <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 py-8 px-4 sm:px-6 lg:px-8">
//       <div className="max-w-[1920px] mx-auto">
//         {/* Header - Professional Design */}
//         <div className="bg-white rounded-xl shadow-xl p-8 mb-6 border-l-4 border-indigo-600">
//           <div className="flex items-center justify-between">
//             <div>
//               <h1 className="text-4xl font-bold text-gray-900 mb-2 flex items-center">
//                 Invoices
//               </h1>
//             </div>
//             <div className="flex space-x-3">
//               {selectedInvoices.length > 0 && (
//                 <button
//                   onClick={handleBulkDelete}
//                   className="bg-red-600 text-white px-6 py-3 rounded-lg font-semibold hover:bg-red-700 transition-all duration-200 shadow-lg hover:shadow-xl flex items-center"
//                 >
//                   <svg className="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 20 20">
//                     <path fillRule="evenodd" d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z" clipRule="evenodd" />
//                   </svg>
//                   Delete Selected ({selectedInvoices.length})
//                 </button>
//               )}
//               <button
//                 onClick={() => navigate('/invoices/new')}
//                 className="bg-gradient-to-r from-indigo-900 to-indigo-700 text-white px-8 py-3 rounded-lg font-bold hover:from-indigo-700 hover:to-indigo-600 transition-all duration-200 shadow-xl hover:shadow-2xl flex items-center"
//               >
//                 <svg className="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 20 20">
//                   <path fillRule="evenodd" d="M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z" clipRule="evenodd" />
//                 </svg>
//                 New Invoice
//               </button>
//             </div>
//           </div>
//         </div>

//         {/* Success/Error Messages */}
//         {success && (
//           <div className="bg-gradient-to-r from-green-50 to-green-100 border-l-4 border-green-500 text-green-800 px-6 py-4 rounded-lg mb-6 shadow-md animate-fade-in">
//             <div className="flex items-center">
//               <svg className="w-6 h-6 mr-3" fill="currentColor" viewBox="0 0 20 20">
//                 <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
//               </svg>
//               <span className="font-semibold">{success}</span>
//             </div>
//           </div>
//         )}
//         {error && (
//           <div className="bg-gradient-to-r from-red-50 to-red-100 border-l-4 border-red-500 text-red-800 px-6 py-4 rounded-lg mb-6 shadow-md animate-fade-in">
//             <div className="flex items-center">
//               <svg className="w-6 h-6 mr-3" fill="currentColor" viewBox="0 0 20 20">
//                 <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
//               </svg>
//               <span className="font-semibold">{error}</span>
//             </div>
//           </div>
//         )}

//         {/* Advanced Filters */}
//         <div className="bg-white rounded-xl shadow-xl p-6 mb-6 border-t-4 border-indigo-600">
//           <h2 className="text-xl font-bold text-gray-900 mb-4 flex items-center">
//             <svg className="w-5 h-5 mr-2 text-indigo-600" fill="currentColor" viewBox="0 0 20 20">
//               <path fillRule="evenodd" d="M3 3a1 1 0 011-1h12a1 1 0 011 1v3a1 1 0 01-.293.707L12 11.414V15a1 1 0 01-.293.707l-2 2A1 1 0 018 17v-5.586L3.293 6.707A1 1 0 013 6V3z" clipRule="evenodd" />
//             </svg>
//             Filter Invoices
//           </h2>

//           <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-4 mb-4">
//             {/* Customer Searchable Dropdown */}
//             <div>
//               <label className="block text-xs font-semibold text-gray-700 mb-1.5">Customer</label>
//               <SearchableSelect
//                 options={customers}
//                 value={filters.customer}
//                 onChange={(id) => setFilters(prev => ({ ...prev, customer: id }))}
//                 placeholder="All Customers"
//               />
//             </div>

//             {/* Invoice Type Dropdown */}
//             <div>
//               <label className="block text-xs font-semibold text-gray-700 mb-1.5">Invoice Type</label>
//               <select
//                 name="invoiceType"
//                 value={filters.invoiceType}
//                 onChange={handleFilterChange}
//                 className="w-full px-3 py-2.5 border-2 border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 text-sm transition-all duration-200"
//               >
//                 <option value="">All Types</option>
//                 <option value="Film">Film</option>
//                 <option value="Site">Site</option>
//               </select>
//             </div>

//             {/* Invoice Date Picker */}
//             <div>
//               <label className="block text-xs font-semibold text-gray-700 mb-1.5">Invoice Date</label>
//               <input
//                 type={filters.invoiceDate ? 'date' : 'text'}
//                 name="invoiceDate"
//                 value={filters.invoiceDate}
//                 onChange={handleFilterChange}
//                 onFocus={(e) => {
//                   e.target.type = 'date';
//                   e.target.showPicker?.();
//                 }}
//                 onBlur={(e) => {
//                   if (!e.target.value) {
//                     e.target.type = 'text';
//                   }
//                 }}
//                 placeholder="Select date"
//                 className="w-full px-3 py-2.5 border-2 border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 text-sm transition-all duration-200"
//               />
//             </div>

//             {/* Created Date Picker */}
//             <div>
//               <label className="block text-xs font-semibold text-gray-700 mb-1.5">Created Date</label>
//               <input
//                 type={filters.createdDate ? 'date' : 'text'}
//                 name="createdDate"
//                 value={filters.createdDate}
//                 onChange={handleFilterChange}
//                 onFocus={(e) => {
//                   e.target.type = 'date';
//                   e.target.showPicker?.();
//                 }}
//                 onBlur={(e) => {
//                   if (!e.target.value) {
//                     e.target.type = 'text';
//                   }
//                 }}
//                 placeholder="Select date"
//                 className="w-full px-3 py-2.5 border-2 border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 text-sm transition-all duration-200"
//               />
//             </div>

//             {/* Financial Year Dropdown */}
//             <div>
//               <label className="block text-xs font-semibold text-gray-700 mb-1.5">Financial Year</label>
//               <select
//                 name="financialYear"
//                 value={filters.financialYear}
//                 onChange={handleFilterChange}
//                 className="w-full px-3 py-2.5 border-2 border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 text-sm transition-all duration-200"
//               >
//                 <option value="">All Years</option>
//                 {financialYears.map((year) => (
//                   <option key={year} value={year}>
//                     {year}
//                   </option>
//                 ))}
//               </select>
//             </div>
//           </div>

//           <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
//             {/* Invoice Number Input */}
//             <div>
//               <label className="block text-xs font-semibold text-gray-700 mb-1.5">Invoice Number</label>
//               <input
//                 type="text"
//                 name="invoiceNumber"
//                 value={filters.invoiceNumber}
//                 onChange={handleFilterChange}
//                 placeholder="Search by invoice number"
//                 className="w-full px-3 py-2.5 border-2 border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 text-sm transition-all duration-200"
//               />
//             </div>

//             {/* Status Dropdown */}
//             <div>
//               <label className="block text-xs font-semibold text-gray-700 mb-1.5">Status</label>
//               <select
//                 name="status"
//                 value={filters.status}
//                 onChange={handleFilterChange}
//                 className="w-full px-3 py-2.5 border-2 border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 text-sm transition-all duration-200"
//               >
//                 <option value="">All Status</option>
//                 <option value="paid">Paid</option>
//                 <option value="pending">Pending</option>
//                 <option value="overdue">Overdue</option>
//                 <option value="cancelled">Cancelled</option>
//               </select>
//             </div>

//             {/* Items per page */}
//             <div>
//               <label className="block text-xs font-semibold text-gray-700 mb-1.5">Items per page</label>
//               <select
//                 value={limit}
//                 onChange={(e) => {
//                   setLimit(parseInt(e.target.value));
//                   setCurrentPage(1);
//                 }}
//                 className="w-full px-3 py-2.5 border-2 border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 text-sm transition-all duration-200"
//               >
//                 <option value="10">10 per page</option>
//                 <option value="25">25 per page</option>
//                 <option value="50">50 per page</option>
//                 <option value="100">100 per page</option>
//               </select>
//             </div>

//             {/* Action Buttons */}
//             <div className="flex items-end space-x-2">
//               <button
//                 onClick={handleSearch}
//                 className="flex-1 bg-indigo-600 text-white px-4 py-2.5 rounded-lg font-semibold hover:bg-indigo-700 transition-all duration-200 shadow-lg flex items-center justify-center"
//               >
//                 <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
//                 </svg>
//                 Search
//               </button>
//               <button
//                 onClick={handleClearFilters}
//                 className="flex-1 bg-gray-500 text-white px-4 py-2.5 rounded-lg font-semibold hover:bg-gray-600 transition-all duration-200 shadow-lg flex items-center justify-center"
//               >
//                 <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
//                 </svg>
//                 Clear
//               </button>
//             </div>
//           </div>
//         </div>
//         {/* Invoices Table */}
//         <div className="bg-white rounded-xl shadow-xl overflow-hidden">
//           <div className="overflow-x-auto">
//             <table className="w-full">
//               <thead className="bg-gradient-to-r from-indigo-900 to-indigo-900 text-white">
//                 <tr>
//                   <th className="px-4 py-4 text-left text-sm font-bold">
//                     <input
//                       type="checkbox"
//                       checked={selectAll}
//                       onChange={handleSelectAll}
//                       className="w-5 h-5 text-indigo-600 border-gray-300 rounded focus:ring-indigo-500"
//                     />
//                   </th>
//                   <th className="px-4 py-4 text-left text-sm font-bold">Sr. No</th>
//                   <th className="px-4 py-4 text-left text-sm font-bold">Invoice Number</th>
//                   <th className="px-4 py-4 text-left text-sm font-bold">Customer</th>
//                   <th className="px-4 py-4 text-left text-sm font-bold">Invoice Type</th>
//                   <th className="px-4 py-4 text-left text-sm font-bold">Report Numbers</th>
//                   <th className="px-4 py-4 text-left text-sm font-bold">Financial Year</th>
//                   <th className="px-4 py-4 text-left text-sm font-bold">Invoice Date</th>
//                   <th className="px-4 py-4 text-left text-sm font-bold">Total Amount</th>
//                   <th className="px-4 py-4 text-left text-sm font-bold">Created By</th>
//                   <th className="px-4 py-4 text-left text-sm font-bold">Created At</th>
//                   <th className="px-4 py-4 text-center text-sm font-bold">Actions</th>
//                 </tr>
//               </thead>
//               <tbody className="divide-y divide-gray-200">
//                 {loading ? (
//                   <tr>
//                     <td colSpan="12" className="px-4 py-16 text-center">
//                       <div className="flex flex-col items-center justify-center">
//                         <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-b-4 border-indigo-600 mb-4"></div>
//                         <p className="text-gray-600 text-lg font-semibold">Loading invoices...</p>
//                       </div>
//                     </td>
//                   </tr>
//                 ) : invoices.length === 0 ? (
//                   <tr>
//                     <td colSpan="12" className="px-4 py-16 text-center">
//                       <div className="flex flex-col items-center justify-center">
//                         <svg className="w-20 h-20 text-gray-400 mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                           <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
//                         </svg>
//                         <p className="text-gray-600 text-xl font-semibold mb-2">No invoices found</p>
//                         <p className="text-gray-400">Try adjusting your filters or create a new invoice</p>
//                       </div>
//                     </td>
//                   </tr>
//                 ) : (
//                   invoices.map((invoice, index) => (
//                     <tr key={invoice.id} className="hover:bg-indigo-50 transition-colors duration-150">
//                       <td className="px-4 py-4">
//                         <input
//                           type="checkbox"
//                           checked={selectedInvoices.includes(invoice.id)}
//                           onChange={() => handleSelectInvoice(invoice.id)}
//                           className="w-5 h-5 text-indigo-600 border-gray-300 rounded focus:ring-indigo-500"
//                         />
//                       </td>
//                       <td className="px-4 py-4 text-sm font-medium text-gray-700">
//                         {totalInvoices - ((currentPage - 1) * limit + index)}
//                       </td>
//                       <td className="px-4 py-4 text-sm font-bold text-indigo-600">
//                         {invoice.invoice_number}
//                       </td>
//                       <td className="px-4 py-4 text-sm text-gray-700 font-medium">
//                         {invoice.customer_name || 'N/A'}
//                       </td>
//                       <td className="px-4 py-4">
//                         <span className={`px-3 py-1 text-xs font-bold rounded-full ${getInvoiceTypeBadge(invoice.invoice_type)}`}>
//                           {invoice.invoice_type}
//                         </span>
//                       </td>
//                       <td className="px-4 py-4 text-sm text-gray-700 max-w-xs">
//                         {invoice.report_numbers ? (
//                           <div className="truncate" title={invoice.report_numbers}>
//                             {invoice.report_numbers}
//                           </div>
//                         ) : (
//                           <span className="text-gray-400 italic">No Reports Attached</span>
//                         )}
//                       </td>
//                       <td className="px-4 py-4 text-sm text-gray-700 font-medium">
//                         {invoice.financial_year}
//                       </td>
//                       <td className="px-4 py-4 text-sm text-gray-700">
//                         {formatDate(invoice.invoice_date)}
//                       </td>
//                       <td className="px-4 py-4 text-sm font-bold text-green-700">
//                         ₹{parseFloat(invoice.total_amount || 0).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
//                       </td>
//                       <td className="px-4 py-4 text-sm text-gray-700">
//                         {invoice.created_by_name || 'N/A'}
//                       </td>
//                       <td className="px-4 py-4 text-sm text-gray-700">
//                         {formatDateTime(invoice.created_at)}
//                       </td>
//                       <td className="px-4 py-4">
//                         <div className="flex items-center justify-center space-x-2">
//                           {/* Edit Button */}
//                           <button
//                             onClick={() => handleEdit(invoice.id)}
//                             className="p-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition-all duration-200 shadow-md hover:shadow-lg transform hover:-translate-y-0.5"
//                             title="Edit Invoice"
//                           >
//                             <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                               <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
//                             </svg>
//                           </button>

//                           {/* Download Invoice Button */}
//                           <button
//                             onClick={() => handleDownloadInvoice(invoice.id, invoice.invoice_number)}
//                             className="p-2 bg-green-500 text-white rounded-lg hover:bg-green-600 transition-all duration-200 shadow-md hover:shadow-lg transform hover:-translate-y-0.5"
//                             title="Download Invoice PDF"
//                           >
//                             <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                               <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
//                             </svg>
//                           </button>

//                           {/* Download Statement Button */}
//                           <button
//                             onClick={() => handleDownloadStatement(invoice.id, invoice.invoice_number)}
//                             className="p-2 bg-purple-500 text-white rounded-lg hover:bg-purple-600 transition-all duration-200 shadow-md hover:shadow-lg transform hover:-translate-y-0.5"
//                             title="Download Statement PDF"
//                           >
//                             <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                               <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
//                             </svg>
//                           </button>

//                           {/* Delete Button */}
//                           <button
//                             onClick={() => handleDelete(invoice.id, invoice.invoice_number)}
//                             className="p-2 bg-red-500 text-white rounded-lg hover:bg-red-600 transition-all duration-200 shadow-md hover:shadow-lg transform hover:-translate-y-0.5"
//                             title="Delete Invoice"
//                           >
//                             <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                               <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
//                             </svg>
//                           </button>
//                         </div>
//                       </td>
//                     </tr>
//                   ))
//                 )}
//               </tbody>
//             </table>
//           </div>

//           {/* Pagination */}
//           {!loading && invoices.length > 0 && (
//             <div className="bg-gray-50 px-6 py-4 border-t border-gray-200">
//               <div className="flex items-center justify-between">
//                 <div className="text-sm font-medium text-gray-700">
//                   Showing <span className="font-bold text-indigo-600">{(currentPage - 1) * limit + 1}</span> to{' '}
//                   <span className="font-bold text-indigo-600">
//                     {Math.min(currentPage * limit, totalInvoices)}
//                   </span>{' '}
//                   of <span className="font-bold text-indigo-600">{totalInvoices}</span> results
//                 </div>
//                 <div className="flex space-x-2">
//                   <button
//                     onClick={() => setCurrentPage(prev => Math.max(1, prev - 1))}
//                     disabled={currentPage === 1}
//                     className={`px-4 py-2 rounded-lg font-semibold transition-all duration-200 ${currentPage === 1
//                       ? 'bg-gray-200 text-gray-400 cursor-not-allowed'
//                       : 'bg-indigo-600 text-white hover:bg-indigo-700 shadow-md hover:shadow-lg'
//                       }`}
//                   >
//                     Previous
//                   </button>

//                   {[...Array(totalPages)].map((_, i) => {
//                     const pageNum = i + 1;
//                     if (
//                       pageNum === 1 ||
//                       pageNum === totalPages ||
//                       (pageNum >= currentPage - 1 && pageNum <= currentPage + 1)
//                     ) {
//                       return (
//                         <button
//                           key={pageNum}
//                           onClick={() => setCurrentPage(pageNum)}
//                           className={`px-4 py-2 rounded-lg font-semibold transition-all duration-200 ${currentPage === pageNum
//                             ? 'bg-indigo-600 text-white shadow-lg'
//                             : 'bg-gray-200 text-gray-700 hover:bg-gray-300 shadow-md'
//                             }`}
//                         >
//                           {pageNum}
//                         </button>
//                       );
//                     } else if (pageNum === currentPage - 2 || pageNum === currentPage + 2) {
//                       return <span key={pageNum} className="px-2 text-gray-500 font-bold">...</span>;
//                     }
//                     return null;
//                   })}

//                   <button
//                     onClick={() => setCurrentPage(prev => Math.min(totalPages, prev + 1))}
//                     disabled={currentPage === totalPages}
//                     className={`px-4 py-2 rounded-lg font-semibold transition-all duration-200 ${currentPage === totalPages
//                       ? 'bg-gray-200 text-gray-400 cursor-not-allowed'
//                       : 'bg-indigo-600 text-white hover:bg-indigo-700 shadow-md hover:shadow-lg'
//                       }`}
//                   >
//                     Next
//                   </button>
//                 </div>
//               </div>
//             </div>
//           )}
//         </div>
//       </div>

//       {/* Download Options Modal */}
//       {showDownloadModal && (
//         <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
//           <div className="bg-white rounded-lg shadow-xl p-6 max-w-md w-full mx-4">
//             <h2 className="text-2xl font-bold text-gray-900 mb-4">Download Invoice Options</h2>
//             <p className="text-sm text-gray-600 mb-6">
//               Invoice: <span className="font-semibold text-indigo-600">{downloadInvoiceId?.number}</span>
//             </p>

//             {/* Download Options */}
//             <div className="space-y-4 mb-6">
//               {/* With Letterhead */}
//               <label className="flex items-start cursor-pointer group">
//                 <input
//                   type="checkbox"
//                   checked={downloadOptions.withLetterhead}
//                   onChange={(e) => setDownloadOptions(prev => ({
//                     ...prev,
//                     withLetterhead: e.target.checked
//                   }))}
//                   className="mt-1 w-5 h-5 text-indigo-600 border-gray-300 rounded focus:ring-indigo-500"
//                 />
//                 <div className="ml-3">
//                   <span className="text-sm font-medium text-gray-900 group-hover:text-indigo-600">
//                     With Letterhead
//                   </span>
//                   <p className="text-xs text-gray-500">Include company letterhead at the top</p>
//                 </div>
//               </label>

//               {/* With IGST */}
//               <label className="flex items-start cursor-pointer group">
//                 <input
//                   type="checkbox"
//                   checked={downloadOptions.withIGST}
//                   onChange={(e) => setDownloadOptions(prev => ({
//                     ...prev,
//                     withIGST: e.target.checked
//                   }))}
//                   className="mt-1 w-5 h-5 text-indigo-600 border-gray-300 rounded focus:ring-indigo-500"
//                 />
//                 <div className="ml-3">
//                   <span className="text-sm font-medium text-gray-900 group-hover:text-indigo-600">
//                     IGST Invoice
//                   </span>
//                   <p className="text-xs text-gray-500">Generate with IGST instead of CGST+SGST</p>
//                 </div>
//               </label>

//               {/* Remember Choice */}
//               <label className="flex items-start cursor-pointer group border-t pt-4">
//                 <input
//                   type="checkbox"
//                   checked={downloadOptions.rememberChoice}
//                   onChange={(e) => setDownloadOptions(prev => ({
//                     ...prev,
//                     rememberChoice: e.target.checked
//                   }))}
//                   className="mt-1 w-5 h-5 text-green-600 border-gray-300 rounded focus:ring-green-500"
//                 />
//                 <div className="ml-3">
//                   <span className="text-sm font-medium text-gray-900 group-hover:text-green-600">
//                     Remember my choice
//                   </span>
//                   <p className="text-xs text-gray-500">Save these preferences for future downloads</p>
//                 </div>
//               </label>
//             </div>

//             {/* Action Buttons */}
//             <div className="flex space-x-3">
//               <button
//                 onClick={handleDownloadConfirm}
//                 className="flex-1 bg-gradient-to-r from-indigo-900 to-indigo-900 text-white px-4 py-2 rounded-lg font-medium hover:from-indigo-800 hover:to-indigo-900 transition"
//               >
//                 Download PDF
//               </button>
//               <button
//                 onClick={() => {
//                   setShowDownloadModal(false);
//                   setDownloadInvoiceId(null);
//                 }}
//                 className="px-4 py-2 border border-gray-300 rounded-lg font-medium text-gray-700 hover:bg-gray-50 transition"
//               >
//                 Cancel
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* DPIN Modal */}
//       <DpinModal
//         isOpen={showDpinModal}
//         onClose={() => {
//           setShowDpinModal(false);
//           setInvoiceToDelete(null);
//           setBulkDeleteMode(false);
//         }}
//         onSuccess={handleDpinSuccess}
//         itemType={
//           bulkDeleteMode
//             ? `${selectedInvoices.length} invoice(s)`
//             : invoiceToDelete?.isCancel
//               ? `invoice ${invoiceToDelete?.number} (Cancel)`
//               : `invoice ${invoiceToDelete?.number}`
//         }
//       />
//     </div>
//   );
// };

// export default Invoices;











import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import Cookies from 'js-cookie';
import DpinModal from './DpinModal';
import SearchableSelect from './SearchableSelect';


const Invoices = () => {
  const navigate = useNavigate();
  const [invoices, setInvoices] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  // Pagination
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalInvoices, setTotalInvoices] = useState(0);
  const [limit, setLimit] = useState(10);

  // Checkbox selection
  const [selectedInvoices, setSelectedInvoices] = useState([]);
  const [selectAll, setSelectAll] = useState(false);

  // DPIN Modal states
  const [showDpinModal, setShowDpinModal] = useState(false);
  const [invoiceToDelete, setInvoiceToDelete] = useState(null);
  const [bulkDeleteMode, setBulkDeleteMode] = useState(false);

  // Download Modal states
  const [showDownloadModal, setShowDownloadModal] = useState(false);
  const [downloadInvoiceId, setDownloadInvoiceId] = useState(null);
  const [downloadOptions, setDownloadOptions] = useState({
    withLetterhead: false,
    withIGST: false,
    rememberChoice: false
  });

  // Filter states
  const [customers, setCustomers] = useState([]);
  const [financialYears, setFinancialYears] = useState([]);
  const [filters, setFilters] = useState({
    customer: '',
    invoiceDate: '',
    createdDate: '',
    financialYear: getCurrentFinancialYear(),
    invoiceNumber: '',
    status: '',
    invoiceType: ''
  });

  // ── Format invoice number — PNS/INV/2026-2027/1 → PNS/INV/26-27/1 ──
  function formatInvoiceNumber(invoiceNumber) {
    if (!invoiceNumber) return '';
    return invoiceNumber.replace(
      /(\d{4})-(\d{4})/,
      (match, y1, y2) => `${y1.slice(-2)}-${y2.slice(-2)}`
    );
  }

  // Helper function to get current financial year
  function getCurrentFinancialYear() {
    const today = new Date();
    const currentMonth = today.getMonth() + 1;
    const currentYear = today.getFullYear();

    if (currentMonth >= 4) {
      return `${currentYear}-${currentYear + 1}`;
    } else {
      return `${currentYear - 1}-${currentYear}`;
    }
  }

  // Generate financial years list
  function generateFinancialYears() {
    const years = [];
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();

    for (let year = 2020; year <= currentYear + 1; year++) {
      years.push(`${year}-${year + 1}`);
    }

    return years;
  }

  // Load saved download preferences
  useEffect(() => {
    const savedOptions = localStorage.getItem('invoiceDownloadPreferences');
    if (savedOptions) {
      setDownloadOptions(JSON.parse(savedOptions));
    }
  }, []);

  useEffect(() => {
    fetchCustomers();
    setFinancialYears(generateFinancialYears());
    fetchInvoices();
  }, []);

  useEffect(() => {
    fetchInvoices();
  }, [currentPage, limit]);

  const fetchCustomers = async () => {
    try {
      const token = Cookies.get('token');
      // const response = await axios.get('https://app-pune-ndt.cloud/api/customers', {
      const response = await axios.get('https://app-pune-ndt.cloud/api/customers/all', {
        headers: { Authorization: `Bearer ${token}` }
      });
      if (response.data.success) {
        setCustomers(response.data.data);
      }
    } catch (err) {
      console.error('Error fetching customers:', err);
    }
  };

  const fetchInvoices = async () => {
    setLoading(true);
    setError('');

    try {
      const token = Cookies.get('token');
      const response = await axios.get('https://app-pune-ndt.cloud/api/invoices/filter', {
        headers: { Authorization: `Bearer ${token}` },
        params: {
          page: currentPage,
          limit: limit,
          customer: filters.customer,
          invoiceDate: filters.invoiceDate,
          createdDate: filters.createdDate,
          financialYear: filters.financialYear,
          invoiceNumber: filters.invoiceNumber,
          status: filters.status,
          invoiceType: filters.invoiceType
        }
      });

      if (response.data.success) {
        setInvoices(response.data.data);
        setTotalPages(response.data.pagination.totalPages);
        setTotalInvoices(response.data.pagination.total);
      }
    } catch (err) {
      setError('Failed to fetch invoices');
      console.error('Error fetching invoices:', err);
    } finally {
      setLoading(false);
    }
  };

  // Handle filter change
  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters(prev => ({
      ...prev,
      [name]: value
    }));
  };

  // Handle search
  const handleSearch = () => {
    setCurrentPage(1);
    fetchInvoices();
  };

  // Handle clear filters
  const handleClearFilters = async () => {
    const clearedFilters = {
      customer: '',
      invoiceDate: '',
      createdDate: '',
      financialYear: getCurrentFinancialYear(),
      invoiceNumber: '',
      status: '',
      invoiceType: ''
    };

    setFilters(clearedFilters);
    setCurrentPage(1);

    setLoading(true);
    setError('');

    try {
      const token = Cookies.get('token');
      const response = await axios.get('https://app-pune-ndt.cloud/api/invoices/filter', {
        headers: { Authorization: `Bearer ${token}` },
        params: {
          page: 1,
          limit: limit,
          ...clearedFilters
        }
      });

      if (response.data.success) {
        setInvoices(response.data.data);
        setTotalPages(response.data.pagination.totalPages);
        setTotalInvoices(response.data.pagination.total);
      }
    } catch (err) {
      setError('Failed to fetch invoices');
      console.error('Error fetching invoices:', err);
    } finally {
      setLoading(false);
    }
  };

  // Handle checkbox selection
  const handleSelectAll = (e) => {
    setSelectAll(e.target.checked);
    if (e.target.checked) {
      setSelectedInvoices(invoices.map(invoice => invoice.id));
    } else {
      setSelectedInvoices([]);
    }
  };

  const handleSelectInvoice = (invoiceId) => {
    if (selectedInvoices.includes(invoiceId)) {
      setSelectedInvoices(selectedInvoices.filter(id => id !== invoiceId));
      setSelectAll(false);
    } else {
      const newSelected = [...selectedInvoices, invoiceId];
      setSelectedInvoices(newSelected);
      if (newSelected.length === invoices.length) {
        setSelectAll(true);
      }
    }
  };

  // Handle Edit
  const handleEdit = (invoiceId) => {
    navigate(`/invoices/edit/${invoiceId}`);
  };

  // Handle View
  const handleView = (invoiceId) => {
    navigate(`/invoices/view/${invoiceId}`);
  };

  // Handle Download Invoice - Open Modal
  const handleDownloadInvoice = (invoiceId, invoiceNumber) => {
    setDownloadInvoiceId({ id: invoiceId, number: invoiceNumber });
    setShowDownloadModal(true);
  };

  // Handle Download Confirm
  const handleDownloadConfirm = async () => {
    try {
      if (downloadOptions.rememberChoice) {
        localStorage.setItem('invoiceDownloadPreferences', JSON.stringify(downloadOptions));
      }

      setSuccess(`Generating invoice PDF for ${downloadInvoiceId.number}...`);

      const token = Cookies.get('token');
      const response = await axios.get(
        `https://app-pune-ndt.cloud/api/invoices/${downloadInvoiceId.id}/download`,
        {
          headers: { Authorization: `Bearer ${token}` },
          params: {
            withLetterhead: downloadOptions.withLetterhead,
            withIGST: downloadOptions.withIGST
          },
          responseType: 'blob'
        }
      );

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `Invoice_${downloadInvoiceId.number.replace(/\//g, '_')}.pdf`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);

      setShowDownloadModal(false);
      setDownloadInvoiceId(null);
      setSuccess(`Invoice ${downloadInvoiceId.number} downloaded successfully!`);
      setTimeout(() => setSuccess(''), 3000);
    } catch (err) {
      setError('Failed to download invoice');
      console.error('Error downloading invoice:', err);
      setTimeout(() => setError(''), 5000);
    }
  };

  // Handle Download Statement
  const handleDownloadStatement = async (invoiceId, invoiceNumber) => {
    try {
      setSuccess(`Generating statement PDF for ${invoiceNumber}...`);

      const token = Cookies.get('token');
      const response = await axios.get(
        `https://app-pune-ndt.cloud/api/invoices/${invoiceId}/statement`,
        {
          headers: { Authorization: `Bearer ${token}` },
          responseType: 'blob'
        }
      );

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `Statement_${invoiceNumber.replace(/\//g, '_')}.pdf`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);

      setSuccess(`Statement ${invoiceNumber} downloaded successfully!`);
      setTimeout(() => setSuccess(''), 3000);
    } catch (err) {
      setError('Failed to download statement');
      console.error('Error downloading statement:', err);
      setTimeout(() => setError(''), 5000);
    }
  };

  // Handle Delete - Open DPIN Modal
  const handleDelete = (invoiceId, invoiceNumber) => {
    setInvoiceToDelete({ id: invoiceId, number: invoiceNumber });
    setBulkDeleteMode(false);
    setShowDpinModal(true);
  };

  // Handle Delete Confirmed
  const handleDeleteConfirmed = async () => {
    try {
      const token = Cookies.get('token');
      const response = await axios.delete(
        `https://app-pune-ndt.cloud/api/invoices/${invoiceToDelete.id}`,
        {
          headers: { Authorization: `Bearer ${token}` }
        }
      );

      if (response.data.success) {
        setSuccess(`Invoice ${invoiceToDelete.number} deleted successfully! All reports have been set to Unbilled.`);
        setSelectedInvoices(prev => prev.filter(id => id !== invoiceToDelete.id));
        fetchInvoices();
        setInvoiceToDelete(null);
        setTimeout(() => setSuccess(''), 5000);
      }
    } catch (err) {
      setError('Failed to delete invoice');
      console.error('Error deleting invoice:', err);
      setTimeout(() => setError(''), 5000);
    }
  };

  // Handle Cancel (Delete Invoice Completely)
  const handleCancel = async (invoiceId, invoiceNumber) => {
    setInvoiceToDelete({ id: invoiceId, number: invoiceNumber, isCancel: true });
    setBulkDeleteMode(false);
    setShowDpinModal(true);
  };

  // Handle Cancel Confirmed
  const handleCancelConfirmed = async () => {
    try {
      const token = Cookies.get('token');
      const response = await axios.post(
        `https://app-pune-ndt.cloud/api/invoices/${invoiceToDelete.id}/cancel`,
        {},
        {
          headers: { Authorization: `Bearer ${token}` }
        }
      );

      if (response.data.success) {
        setSuccess(`Invoice ${invoiceToDelete.number} cancelled successfully! All reports have been set to Unbilled.`);
        setSelectedInvoices(prev => prev.filter(id => id !== invoiceToDelete.id));
        fetchInvoices();
        setInvoiceToDelete(null);
        setTimeout(() => setSuccess(''), 5000);
      }
    } catch (err) {
      setError('Failed to cancel invoice');
      console.error('Error cancelling invoice:', err);
      setTimeout(() => setError(''), 5000);
    }
  };

  // Handle Bulk Delete - Open DPIN Modal
  const handleBulkDelete = () => {
    if (selectedInvoices.length === 0) {
      alert('Please select invoices to delete');
      return;
    }
    setBulkDeleteMode(true);
    setShowDpinModal(true);
  };

  // Handle Bulk Delete Confirmed
  const handleBulkDeleteConfirmed = async () => {
    try {
      const token = Cookies.get('token');
      const response = await axios.post(
        'https://app-pune-ndt.cloud/api/invoices/bulk-delete',
        { invoiceIds: selectedInvoices },
        {
          headers: { Authorization: `Bearer ${token}` }
        }
      );

      if (response.data.success) {
        setSuccess(`${selectedInvoices.length} invoice(s) deleted successfully! All associated reports have been set to Unbilled.`);
        setSelectedInvoices([]);
        setSelectAll(false);
        fetchInvoices();
        setTimeout(() => setSuccess(''), 5000);
      }
    } catch (err) {
      setError('Failed to delete invoices');
      console.error('Error deleting invoices:', err);
      setTimeout(() => setError(''), 5000);
    }
  };

  // Handle DPIN Success
  const handleDpinSuccess = () => {
    if (bulkDeleteMode) {
      handleBulkDeleteConfirmed();
    } else if (invoiceToDelete?.isCancel) {
      handleCancelConfirmed();
    } else {
      handleDeleteConfirmed();
    }
  };

  // Format date
  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = String(date.getFullYear()).slice(-2);
    return `${day}-${month}-${year}`;
  };

  // Format datetime
  const formatDateTime = (dateString) => {
    if (!dateString) return 'N/A';
    const date = new Date(dateString);
    return date.toLocaleString('en-IN', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false
    });
  };

  // Get invoice type badge color
  const getInvoiceTypeBadge = (type) => {
    return type === 'Film'
      ? 'bg-blue-100 text-blue-800'
      : 'bg-purple-100 text-purple-800';
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 py-8 px-4 sm:px-6 lg:px-8">
      <div className="max-w-[1920px] mx-auto">

        {/* Header */}
        <div className="bg-white rounded-xl shadow-xl p-8 mb-6 border-l-4 border-indigo-600">
          <div className="flex items-center justify-between">
            <div>
              <h1 className="text-4xl font-bold text-gray-900 mb-2 flex items-center">
                Invoices
              </h1>
            </div>
            <div className="flex space-x-3">
              {selectedInvoices.length > 0 && (
                <button
                  onClick={handleBulkDelete}
                  className="bg-red-600 text-white px-6 py-3 rounded-lg font-semibold hover:bg-red-700 transition-all duration-200 shadow-lg hover:shadow-xl flex items-center"
                >
                  <svg className="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z" clipRule="evenodd" />
                  </svg>
                  Delete Selected ({selectedInvoices.length})
                </button>
              )}
              <button
                onClick={() => navigate('/invoices/new')}
                className="bg-gradient-to-r from-indigo-900 to-indigo-700 text-white px-8 py-3 rounded-lg font-bold hover:from-indigo-700 hover:to-indigo-600 transition-all duration-200 shadow-xl hover:shadow-2xl flex items-center"
              >
                <svg className="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z" clipRule="evenodd" />
                </svg>
                New Invoice
              </button>
            </div>
          </div>
        </div>

        {/* Success/Error Messages */}
        {success && (
          <div className="bg-gradient-to-r from-green-50 to-green-100 border-l-4 border-green-500 text-green-800 px-6 py-4 rounded-lg mb-6 shadow-md">
            <div className="flex items-center">
              <svg className="w-6 h-6 mr-3" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
              </svg>
              <span className="font-semibold">{success}</span>
            </div>
          </div>
        )}
        {error && (
          <div className="bg-gradient-to-r from-red-50 to-red-100 border-l-4 border-red-500 text-red-800 px-6 py-4 rounded-lg mb-6 shadow-md">
            <div className="flex items-center">
              <svg className="w-6 h-6 mr-3" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
              </svg>
              <span className="font-semibold">{error}</span>
            </div>
          </div>
        )}

        {/* Advanced Filters */}
        <div className="bg-white rounded-xl shadow-xl p-6 mb-6 border-t-4 border-indigo-600">
          <h2 className="text-xl font-bold text-gray-900 mb-4 flex items-center">
            <svg className="w-5 h-5 mr-2 text-indigo-600" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M3 3a1 1 0 011-1h12a1 1 0 011 1v3a1 1 0 01-.293.707L12 11.414V15a1 1 0 01-.293.707l-2 2A1 1 0 018 17v-5.586L3.293 6.707A1 1 0 013 6V3z" clipRule="evenodd" />
            </svg>
            Filter Invoices
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-4 mb-4">
            {/* Customer Searchable Dropdown */}
            <div>
              <label className="block text-xs font-semibold text-gray-700 mb-1.5">Customer</label>
              <SearchableSelect
                options={customers}
                value={filters.customer}
                onChange={(id) => setFilters(prev => ({ ...prev, customer: id }))}
                placeholder="All Customers"
              />
            </div>

            {/* Invoice Type Dropdown */}
            <div>
              <label className="block text-xs font-semibold text-gray-700 mb-1.5">Invoice Type</label>
              <select
                name="invoiceType"
                value={filters.invoiceType}
                onChange={handleFilterChange}
                className="w-full px-3 py-2.5 border-2 border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 text-sm transition-all duration-200"
              >
                <option value="">All Types</option>
                <option value="Film">Film</option>
                <option value="Site">Site</option>
              </select>
            </div>

            {/* Invoice Date Picker */}
            <div>
              <label className="block text-xs font-semibold text-gray-700 mb-1.5">Invoice Date</label>
              <input
                type={filters.invoiceDate ? 'date' : 'text'}
                name="invoiceDate"
                value={filters.invoiceDate}
                onChange={handleFilterChange}
                onFocus={(e) => {
                  e.target.type = 'date';
                  e.target.showPicker?.();
                }}
                onBlur={(e) => {
                  if (!e.target.value) {
                    e.target.type = 'text';
                  }
                }}
                placeholder="Select date"
                className="w-full px-3 py-2.5 border-2 border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 text-sm transition-all duration-200"
              />
            </div>

            {/* Created Date Picker */}
            <div>
              <label className="block text-xs font-semibold text-gray-700 mb-1.5">Created Date</label>
              <input
                type={filters.createdDate ? 'date' : 'text'}
                name="createdDate"
                value={filters.createdDate}
                onChange={handleFilterChange}
                onFocus={(e) => {
                  e.target.type = 'date';
                  e.target.showPicker?.();
                }}
                onBlur={(e) => {
                  if (!e.target.value) {
                    e.target.type = 'text';
                  }
                }}
                placeholder="Select date"
                className="w-full px-3 py-2.5 border-2 border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 text-sm transition-all duration-200"
              />
            </div>

            {/* Financial Year Dropdown */}
            <div>
              <label className="block text-xs font-semibold text-gray-700 mb-1.5">Financial Year</label>
              <select
                name="financialYear"
                value={filters.financialYear}
                onChange={handleFilterChange}
                className="w-full px-3 py-2.5 border-2 border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 text-sm transition-all duration-200"
              >
                <option value="">All Years</option>
                {financialYears.map((year) => (
                  <option key={year} value={year}>
                    {year}
                  </option>
                ))}
              </select>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
            {/* Invoice Number Input */}
            <div>
              <label className="block text-xs font-semibold text-gray-700 mb-1.5">Invoice Number</label>
              <input
                type="text"
                name="invoiceNumber"
                value={filters.invoiceNumber}
                onChange={handleFilterChange}
                placeholder="Search by invoice number"
                className="w-full px-3 py-2.5 border-2 border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 text-sm transition-all duration-200"
              />
            </div>

            {/* Status Dropdown */}
            <div>
              <label className="block text-xs font-semibold text-gray-700 mb-1.5">Status</label>
              <select
                name="status"
                value={filters.status}
                onChange={handleFilterChange}
                className="w-full px-3 py-2.5 border-2 border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 text-sm transition-all duration-200"
              >
                <option value="">All Status</option>
                <option value="paid">Paid</option>
                <option value="pending">Pending</option>
                <option value="overdue">Overdue</option>
                <option value="cancelled">Cancelled</option>
              </select>
            </div>

            {/* Items per page */}
            <div>
              <label className="block text-xs font-semibold text-gray-700 mb-1.5">Items per page</label>
              <select
                value={limit}
                onChange={(e) => {
                  setLimit(parseInt(e.target.value));
                  setCurrentPage(1);
                }}
                className="w-full px-3 py-2.5 border-2 border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 text-sm transition-all duration-200"
              >
                <option value="10">10 per page</option>
                <option value="25">25 per page</option>
                <option value="50">50 per page</option>
                <option value="100">100 per page</option>
              </select>
            </div>

            {/* Action Buttons */}
            <div className="flex items-end space-x-2">
              <button
                onClick={handleSearch}
                className="flex-1 bg-indigo-600 text-white px-4 py-2.5 rounded-lg font-semibold hover:bg-indigo-700 transition-all duration-200 shadow-lg flex items-center justify-center"
              >
                <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                </svg>
                Search
              </button>
              <button
                onClick={handleClearFilters}
                className="flex-1 bg-gray-500 text-white px-4 py-2.5 rounded-lg font-semibold hover:bg-gray-600 transition-all duration-200 shadow-lg flex items-center justify-center"
              >
                <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
                Clear
              </button>
            </div>
          </div>
        </div>

        {/* Invoices Table */}
        <div className="bg-white rounded-xl shadow-xl overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead className="bg-gradient-to-r from-indigo-900 to-indigo-900 text-white">
                <tr>
                  <th className="px-4 py-4 text-left text-sm font-bold">
                    <input
                      type="checkbox"
                      checked={selectAll}
                      onChange={handleSelectAll}
                      className="w-5 h-5 text-indigo-600 border-gray-300 rounded focus:ring-indigo-500"
                    />
                  </th>
                  <th className="px-4 py-4 text-left text-sm font-bold">Sr. No</th>
                  <th className="px-4 py-4 text-left text-sm font-bold">Invoice Number</th>
                  <th className="px-4 py-4 text-left text-sm font-bold">Customer</th>
                  <th className="px-4 py-4 text-left text-sm font-bold">Invoice Type</th>
                  <th className="px-4 py-4 text-left text-sm font-bold">Report Numbers</th>
                  <th className="px-4 py-4 text-left text-sm font-bold">Financial Year</th>
                  <th className="px-4 py-4 text-left text-sm font-bold">Invoice Date</th>
                  <th className="px-4 py-4 text-left text-sm font-bold">Total Amount</th>
                  <th className="px-4 py-4 text-left text-sm font-bold">Created By</th>
                  <th className="px-4 py-4 text-left text-sm font-bold">Created At</th>
                  <th className="px-4 py-4 text-center text-sm font-bold">Actions</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200">
                {loading ? (
                  <tr>
                    <td colSpan="12" className="px-4 py-16 text-center">
                      <div className="flex flex-col items-center justify-center">
                        <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-b-4 border-indigo-600 mb-4"></div>
                        <p className="text-gray-600 text-lg font-semibold">Loading invoices...</p>
                      </div>
                    </td>
                  </tr>
                ) : invoices.length === 0 ? (
                  <tr>
                    <td colSpan="12" className="px-4 py-16 text-center">
                      <div className="flex flex-col items-center justify-center">
                        <svg className="w-20 h-20 text-gray-400 mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                        </svg>
                        <p className="text-gray-600 text-xl font-semibold mb-2">No invoices found</p>
                        <p className="text-gray-400">Try adjusting your filters or create a new invoice</p>
                      </div>
                    </td>
                  </tr>
                ) : (
                  invoices.map((invoice, index) => (
                    <tr key={invoice.id} className="hover:bg-indigo-50 transition-colors duration-150">
                      <td className="px-4 py-4">
                        <input
                          type="checkbox"
                          checked={selectedInvoices.includes(invoice.id)}
                          onChange={() => handleSelectInvoice(invoice.id)}
                          className="w-5 h-5 text-indigo-600 border-gray-300 rounded focus:ring-indigo-500"
                        />
                      </td>
                      <td className="px-4 py-4 text-sm font-medium text-gray-700">
                        {totalInvoices - ((currentPage - 1) * limit + index)}
                      </td>
                      {/* ── formatInvoiceNumber applied to invoice number display ── */}
                      {/* <td className="px-4 py-4 text-sm font-bold text-indigo-600">
                        {formatInvoiceNumber(invoice.invoice_number)}
                      </td> */}
                      <td className="px-4 py-4 text-sm font-bold text-indigo-600">
                        {invoice.invoice_number}
                      </td>
                      <td className="px-4 py-4 text-sm text-gray-700 font-medium">
                        {invoice.customer_name || 'N/A'}
                      </td>
                      <td className="px-4 py-4">
                        <span className={`px-3 py-1 text-xs font-bold rounded-full ${getInvoiceTypeBadge(invoice.invoice_type)}`}>
                          {invoice.invoice_type}
                        </span>
                      </td>
                      <td className="px-4 py-4 text-sm text-gray-700 max-w-xs">
                        {invoice.report_numbers ? (
                          <div className="truncate" title={invoice.report_numbers}>
                            {invoice.report_numbers}
                          </div>
                        ) : (
                          <span className="text-gray-400 italic">No Reports Attached</span>
                        )}
                      </td>
                      <td className="px-4 py-4 text-sm text-gray-700 font-medium">
                        {invoice.financial_year}
                      </td>
                      <td className="px-4 py-4 text-sm text-gray-700">
                        {formatDate(invoice.invoice_date)}
                      </td>
                      <td className="px-4 py-4 text-sm font-bold text-green-700">
                        ₹{parseFloat(invoice.total_amount || 0).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                      </td>
                      <td className="px-4 py-4 text-sm text-gray-700">
                        {invoice.created_by_name || 'N/A'}
                      </td>
                      <td className="px-4 py-4 text-sm text-gray-700">
                        {formatDateTime(invoice.created_at)}
                      </td>
                      <td className="px-4 py-4">
                        <div className="flex items-center justify-center space-x-2">
                          {/* Edit Button */}
                          <button
                            onClick={() => handleEdit(invoice.id)}
                            className="p-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition-all duration-200 shadow-md hover:shadow-lg transform hover:-translate-y-0.5"
                            title="Edit Invoice"
                          >
                            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                            </svg>
                          </button>

                          {/* Download Invoice Button */}
                          <button
                            onClick={() => handleDownloadInvoice(invoice.id, invoice.invoice_number)}
                            className="p-2 bg-green-500 text-white rounded-lg hover:bg-green-600 transition-all duration-200 shadow-md hover:shadow-lg transform hover:-translate-y-0.5"
                            title="Download Invoice PDF"
                          >
                            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                            </svg>
                          </button>

                          {/* Download Statement Button */}
                          <button
                            onClick={() => handleDownloadStatement(invoice.id, invoice.invoice_number)}
                            className="p-2 bg-purple-500 text-white rounded-lg hover:bg-purple-600 transition-all duration-200 shadow-md hover:shadow-lg transform hover:-translate-y-0.5"
                            title="Download Statement PDF"
                          >
                            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                            </svg>
                          </button>

                          {/* Delete Button */}
                          <button
                            onClick={() => handleDelete(invoice.id, invoice.invoice_number)}
                            className="p-2 bg-red-500 text-white rounded-lg hover:bg-red-600 transition-all duration-200 shadow-md hover:shadow-lg transform hover:-translate-y-0.5"
                            title="Delete Invoice"
                          >
                            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                            </svg>
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>

          {/* Pagination */}
          {!loading && invoices.length > 0 && (
            <div className="bg-gray-50 px-6 py-4 border-t border-gray-200">
              <div className="flex items-center justify-between">
                <div className="text-sm font-medium text-gray-700">
                  Showing <span className="font-bold text-indigo-600">{(currentPage - 1) * limit + 1}</span> to{' '}
                  <span className="font-bold text-indigo-600">
                    {Math.min(currentPage * limit, totalInvoices)}
                  </span>{' '}
                  of <span className="font-bold text-indigo-600">{totalInvoices}</span> results
                </div>
                <div className="flex space-x-2">
                  <button
                    onClick={() => setCurrentPage(prev => Math.max(1, prev - 1))}
                    disabled={currentPage === 1}
                    className={`px-4 py-2 rounded-lg font-semibold transition-all duration-200 ${currentPage === 1
                      ? 'bg-gray-200 text-gray-400 cursor-not-allowed'
                      : 'bg-indigo-600 text-white hover:bg-indigo-700 shadow-md hover:shadow-lg'
                      }`}
                  >
                    Previous
                  </button>

                  {[...Array(totalPages)].map((_, i) => {
                    const pageNum = i + 1;
                    if (
                      pageNum === 1 ||
                      pageNum === totalPages ||
                      (pageNum >= currentPage - 1 && pageNum <= currentPage + 1)
                    ) {
                      return (
                        <button
                          key={pageNum}
                          onClick={() => setCurrentPage(pageNum)}
                          className={`px-4 py-2 rounded-lg font-semibold transition-all duration-200 ${currentPage === pageNum
                            ? 'bg-indigo-600 text-white shadow-lg'
                            : 'bg-gray-200 text-gray-700 hover:bg-gray-300 shadow-md'
                            }`}
                        >
                          {pageNum}
                        </button>
                      );
                    } else if (pageNum === currentPage - 2 || pageNum === currentPage + 2) {
                      return <span key={pageNum} className="px-2 text-gray-500 font-bold">...</span>;
                    }
                    return null;
                  })}

                  <button
                    onClick={() => setCurrentPage(prev => Math.min(totalPages, prev + 1))}
                    disabled={currentPage === totalPages}
                    className={`px-4 py-2 rounded-lg font-semibold transition-all duration-200 ${currentPage === totalPages
                      ? 'bg-gray-200 text-gray-400 cursor-not-allowed'
                      : 'bg-indigo-600 text-white hover:bg-indigo-700 shadow-md hover:shadow-lg'
                      }`}
                  >
                    Next
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Download Options Modal */}
      {showDownloadModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg shadow-xl p-6 max-w-md w-full mx-4">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">Download Invoice Options</h2>
            <p className="text-sm text-gray-600 mb-6">
              Invoice: <span className="font-semibold text-indigo-600">{formatInvoiceNumber(downloadInvoiceId?.number)}</span>
            </p>

            {/* Download Options */}
            <div className="space-y-4 mb-6">
              {/* With Letterhead */}
              <label className="flex items-start cursor-pointer group">
                <input
                  type="checkbox"
                  checked={downloadOptions.withLetterhead}
                  onChange={(e) => setDownloadOptions(prev => ({
                    ...prev,
                    withLetterhead: e.target.checked
                  }))}
                  className="mt-1 w-5 h-5 text-indigo-600 border-gray-300 rounded focus:ring-indigo-500"
                />
                <div className="ml-3">
                  <span className="text-sm font-medium text-gray-900 group-hover:text-indigo-600">
                    With Letterhead
                  </span>
                  <p className="text-xs text-gray-500">Include company letterhead at the top</p>
                </div>
              </label>

              {/* With IGST */}
              <label className="flex items-start cursor-pointer group">
                <input
                  type="checkbox"
                  checked={downloadOptions.withIGST}
                  onChange={(e) => setDownloadOptions(prev => ({
                    ...prev,
                    withIGST: e.target.checked
                  }))}
                  className="mt-1 w-5 h-5 text-indigo-600 border-gray-300 rounded focus:ring-indigo-500"
                />
                <div className="ml-3">
                  <span className="text-sm font-medium text-gray-900 group-hover:text-indigo-600">
                    IGST Invoice
                  </span>
                  <p className="text-xs text-gray-500">Generate with IGST instead of CGST+SGST</p>
                </div>
              </label>

              {/* Remember Choice */}
              <label className="flex items-start cursor-pointer group border-t pt-4">
                <input
                  type="checkbox"
                  checked={downloadOptions.rememberChoice}
                  onChange={(e) => setDownloadOptions(prev => ({
                    ...prev,
                    rememberChoice: e.target.checked
                  }))}
                  className="mt-1 w-5 h-5 text-green-600 border-gray-300 rounded focus:ring-green-500"
                />
                <div className="ml-3">
                  <span className="text-sm font-medium text-gray-900 group-hover:text-green-600">
                    Remember my choice
                  </span>
                  <p className="text-xs text-gray-500">Save these preferences for future downloads</p>
                </div>
              </label>
            </div>

            {/* Action Buttons */}
            <div className="flex space-x-3">
              <button
                onClick={handleDownloadConfirm}
                className="flex-1 bg-gradient-to-r from-indigo-900 to-indigo-900 text-white px-4 py-2 rounded-lg font-medium hover:from-indigo-800 hover:to-indigo-900 transition"
              >
                Download PDF
              </button>
              <button
                onClick={() => {
                  setShowDownloadModal(false);
                  setDownloadInvoiceId(null);
                }}
                className="px-4 py-2 border border-gray-300 rounded-lg font-medium text-gray-700 hover:bg-gray-50 transition"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

      {/* DPIN Modal */}
      <DpinModal
        isOpen={showDpinModal}
        onClose={() => {
          setShowDpinModal(false);
          setInvoiceToDelete(null);
          setBulkDeleteMode(false);
        }}
        onSuccess={handleDpinSuccess}
        itemType={
          bulkDeleteMode
            ? `${selectedInvoices.length} invoice(s)`
            : invoiceToDelete?.isCancel
              ? `invoice ${invoiceToDelete?.number} (Cancel)`
              : `invoice ${invoiceToDelete?.number}`
        }
      />
    </div>
  );
};

export default Invoices;